// CRM 2.0 Shortlisted step on the Home card (M2-F9, M2.22): booking amount still due.
// Today's Pay Now button on the card stays as it is; this adds the prototype's box and steps.
import React from "react";
import { NextBox, Steps, inr, niceDate } from "./Crm2Parts";

// actions: the Pay Now button (M3-F2 card); side: the pay timer when an expiry applies (DC-119)
export default function ShortlistedSteps({ allotment, info, actions, side }) {
	const total = Number(allotment?.bookingAmt?.total) || 0;
	const paid = Number(allotment?.paidAmount) || 0;
	const bal = total - paid;
	const sm = info?.salesManager?.name;
	return (
		<>
			<NextBox who="you" actions={actions} side={side} title={paid > 0 ? `Pay the balance booking amount ${inr(bal)}` : `Pay the booking amount ${inr(total)}`}>
				{paid > 0
					? `${inr(paid)} received. Your unit stays Shortlisted until the booking amount is fully paid. Then your Relationship Manager is assigned and your unit becomes Applied.`
					: "This unit is shortlisted for you. When the booking amount is fully paid, your Relationship Manager is assigned and your unit becomes Applied."}
			</NextBox>
			<Steps
				title="Shortlisted"
				sub={paid > 0 ? "Partial payment" : "Payment pending"}
				rows={[
					["ok", "Unit shortlisted", `${niceDate(allotment?.created_at)}${sm ? ` · by your Sales Manager ${sm}` : ""}`],
					["now", `Booking amount ${inr(total)}`, `Paid ${inr(paid)} · balance ${inr(bal)}`],
					["todo", "Unit status: Shortlisted → Applied", "When the booking amount is fully paid"],
					["todo", "Relationship Manager (CRM)", "Assigned when the booking amount is fully paid"],
				]}
			/>
		</>
	);
}
